import { CompanyInterface } from "."

interface sectionsOfCompanyModal {
  sectionName:string
  inputs:fieldsAndValuesType[]
  className?:string
}

interface fieldsAndValuesType {
  label: string
  type: string
  value: keyof CompanyInterface
  placeholder?: string
}

export const companyTypesIds = [
  {
    name:'Cliente',
    id:1
  },
  {
    name:'Fornecedor',
    id:2
  }
]

export const sectionsInModal:sectionsOfCompanyModal[] = [
  {
    sectionName:'companyInfo',
    inputs:[
      {
        label:'CNPJ',
        type:'text',
        value:'cnpj',
        placeholder:'00.000.000/0001-00'
      },
      {
        label:'Razão Social',
        type:'text',
        value:'companyName',
        placeholder:'Digite aqui'
      },
      {
        label:'Inscrição Estadual',
        type:'text',
        value:'stateRegistration',
        placeholder:'Digite aqui'
      },
    ],
  },
  {
    sectionName:'contact',
    inputs:[
      {
        label:'Nome do contato',
        type:'text',
        value:'contactName',
        placeholder:'Digite aqui'
      },
      {
        label:'E-mail',
        type:'email',
        value:'email',
        placeholder:'Digite aqui'
      },
      {
        label:'Telefone',
        type:'text',
        value:'phone',
        placeholder:'Digite aqui'
      },
    ],
  },
  {
    sectionName:'disponibility',
    inputs:[
      {
        label:'Disponibilidade',
        type:'text',
        value:'activedDays',
      },
      {
        label:'Horário de início',
        type:'time',
        value:'startTime'
      },
      {
        label:'Horário final',
        type:'time',
        value:'endTime'
      },
    ],
  },  
  {
    sectionName:'typesAndFunctions',
    className:'typesAndFunctions',
    inputs:[
      // {
      //   label:'Funções',
      //   type:'select',
      //   value:'functions',
      // },
      {
        label:'Tipo de empresa',
        type:'select',
        value:'companyTypes',
      },
    ],
  },
  {
    sectionName:'address',
    className:'address',
    inputs:[
      {
        label:'CEP',
        type:'text',
        value:'cep',
        placeholder:'00000-000'
      },
      {
        label:'Estado',
        type:'text',
        value:'state',
        placeholder:'Digite aqui'
      },
      {
        label:'Cidade',
        type:'text',
        value:'city',
        placeholder:'Digite aqui'
      },
      {
        label:'Bairro',
        type:'text',
        value:'neighborhood',
        placeholder:'Digite aqui'
      },
      {
        label:'Logradouro',
        type:'text',
        value:'street',
        placeholder:'Digite aqui'
      },
      {
        label:'Complemento',
        type:'text',
        value:'complement',
        placeholder:'Digite aqui'
      },
      {
        label:'Número',
        type:'text',
        value:'number',
        placeholder:'Digite aqui'
      },
    ],
  },
]